import { createApp, h } from 'vue';

import createStore from './store';
import I18nVuePlugin from '~/i18n/vue_plugin';

import form from './components/form.vue';

export function initPaymentPage() {
  const el = document.getElementById('js-payment-page');

  if (!el) return null;

  const {
    amountsUrl,
    formUrl,
    amounts,
    cancelMessage,
    discountCode,
    psps,
    selectedPspCode,
    countries,
    inputs,
    required,
    optional,
    paymentTypes,
    selectedPaymentType,
    product,
    productRecurrence,
    orderBump,
    showOrderQuantity,
    merchantContactInfo,
    testimonials
  } = el.dataset;

  const urlParams = new URLSearchParams(window.location.search);

  const store = createStore({
    amountsUrl,
    formUrl,
    amounts: JSON.parse(amounts),
    cancelMessage,
    discountCode,
    psps: JSON.parse(psps),
    selectedPspCode,
    countries: JSON.parse(countries),
    inputs: JSON.parse(inputs),
    required: JSON.parse(required),
    optional: JSON.parse(optional),
    paymentTypes: JSON.parse(paymentTypes),
    selectedPaymentType,
    product: JSON.parse(product),
    productRecurrence: JSON.parse(productRecurrence || null),
    orderBump: JSON.parse(orderBump || null),
    orderQuantity: 1,
    showOrderQuantity: showOrderQuantity == 'true',
    merchantContactInfo: JSON.parse(merchantContactInfo),
    noFocus: !!urlParams.get('nofocus'),
    testimonials: JSON.parse(testimonials)
  });

  const app = createApp({
    render: () => h(form)
  });

  app.use(store);
  app.use(I18nVuePlugin);

  app.mount(el);
}

export const PaymentMethods = Object.freeze({
  AFTERPAY: 'afterpay',
  BANCONTACT: 'bancontact',
  CREDIT_CARD: 'creditcard',
  PAYPAL: 'paypal',
  SEPA_DIRECT_DEBIT: 'direct-debit'
});

export const RequiredPaymentMethodFields = Object.freeze({
  'afterpay': ['firstname', 'name', 'address', 'zipcode', 'city', 'phoneno'],
  'direct-debit': ['firstname', 'name']
});
